(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-2-influencer-cody-garbrandt"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-2-influencer-henry-cejudo"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-2-influencer-mike-tyson"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-2-influencer-vitor-belfort"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-aboutus"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-contact"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-faq"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-influencer-cody-garbrandt"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-influencer-henry-cejudo"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-influencer-mike-tyson"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-influencer-vitor-belfort"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-press"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product__apparel"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product__bundles"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product__refreshers"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-smartcups-tech"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-sustainability"]) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
  $('.popup-video').magnificPopup({
	type:'iframe',
	showCloseBtn: false
  });
});

  } catch(e) { console.error(e); }
})();
})();
